"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascadeFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.CascadeFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M1.5 2.75C1.5 2.05964 2.05964 1.5 2.75 1.5H5.25C5.94036 1.5 6.5 2.05964 6.5 2.75V5.47311C7.08419 4.77216 7.75563 4.14495 8.5 3.60769V2.75C8.5 2.05964 9.05964 1.5 9.75 1.5H13.25C13.9404 1.5 14.5 2.05964 14.5 2.75V6.25C14.5 6.94036 13.9404 7.5 13.25 7.5H9.75C9.05964 7.5 8.5 6.94036 8.5 6.25V5.54164C7.7348 6.24805 7.08977 7.07826 6.59338 8C7.08977 8.92174 7.7348 9.75195 8.5 10.4584V9.75C8.5 9.05964 9.05964 8.5 9.75 8.5H13.25C13.9404 8.5 14.5 9.05964 14.5 9.75V13.25C14.5 13.9404 13.9404 14.5 13.25 14.5H9.75C9.05964 14.5 8.5 13.9404 8.5 13.25V12.3923C7.75563 11.8551 7.08419 11.2278 6.5 10.5269V13.25C6.5 13.9404 5.94036 14.5 5.25 14.5H2.75C2.05964 14.5 1.5 13.9404 1.5 13.25V2.75ZM10 6H13V3H10V6ZM10 10V13H13V10H10Z", fill: colors[0] }));
    },
    name: 'cascade_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M1.5 2.75C1.5 2.05964 2.05964 1.5 2.75 1.5H5.25C5.94036 1.5 6.5 2.05964 6.5 2.75V5.47311C7.08419 4.77216 7.75563 4.14495 8.5 3.60769V2.75C8.5 2.05964 9.05964 1.5 9.75 1.5H13.25C13.9404 1.5 14.5 2.05964 14.5 2.75V6.25C14.5 6.94036 13.9404 7.5 13.25 7.5H9.75C9.05964 7.5 8.5 6.94036 8.5 6.25V5.54164C7.7348 6.24805 7.08977 7.07826 6.59338 8C7.08977 8.92174 7.7348 9.75195 8.5 10.4584V9.75C8.5 9.05964 9.05964 8.5 9.75 8.5H13.25C13.9404 8.5 14.5 9.05964 14.5 9.75V13.25C14.5 13.9404 13.9404 14.5 13.25 14.5H9.75C9.05964 14.5 8.5 13.9404 8.5 13.25V12.3923C7.75563 11.8551 7.08419 11.2278 6.5 10.5269V13.25C6.5 13.9404 5.94036 14.5 5.25 14.5H2.75C2.05964 14.5 1.5 13.9404 1.5 13.25V2.75ZM10 6H13V3H10V6ZM10 10V13H13V10H10Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
